import { render, staticRenderFns } from "./package-dashboard-card.vue?vue&type=template&id=2bb483a5&scoped=true&"
import script from "./package-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./package-dashboard-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb483a5",
  null
  
)

export default component.exports